const t = "_compactButton_fj26q_1", _ = "_ghost_fj26q_5", o = "_disabled_fj26q_8", s = "_white_fj26q_31", e = "_small_fj26q_48", n = "_loader_fj26q_54", c = "_medium_fj26q_58", a = "_spin_fj26q_1", d = {
  compactButton: t,
  ghost: _,
  disabled: o,
  "ghost-inversed": "_ghost-inversed_fj26q_18",
  white: s,
  small: e,
  loader: n,
  medium: c,
  spin: a
};
export {
  t as compactButton,
  d as default,
  o as disabled,
  _ as ghost,
  n as loader,
  c as medium,
  e as small,
  a as spin,
  s as white
};
//# sourceMappingURL=CompactButton.module.scss.js.map
